<template>
	<div>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-{{whereForm}}</span>-{{title}}</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			<div class="body-left">
				<div class="left-head">
					求助人
				</div>
				<div class="left-body">
					<div class="body-item">
						<div class="item-title">
							用户名
						</div>
					</div>
					<div class="body-item">
						<div class="item-title">
							时间线
						</div>
						<div class="item-content">
							创建时间:2022-5-9
						</div>
						<div class="item-content">
							修改时间:2023-8-9
						</div>
					</div>
					<div class="body-item">
						<div class="item-title">
							有相同需求
						</div>
						<div class="item-content">
							用户昵称
						</div>
					</div>
				
			
				</div>
			</div>
			<div class="body-main">
				<div class="main-header">
					<div class="head-left">
						<img src='../../assets/images/earth.png' style="width: 238px;height: 238px;" alt="">
					</div>
					<div class="head-right">
						<div class="title">
							开源海洋观测数据采集与分析
						</div>
						<div class="content">
							<div class="content-l">

								<div class="content-item"><span class="biaoti">学科</span>：<span>海洋仪器</span></div>
								<div class="content-item"> <span class="biaoti">阶段</span>：<span>数据结果</span></div>
								<div class="content-item"> <span class="biaoti">状态</span>：<span
										style="color: #0052D9;">应助中</span></div>
							</div>
							<div class="content-r">
								<div class="content-item"><span class="biaoti">行业</span>：<span>信息产业</span></div>
								<div class="content-item"> <span class="biaoti">关 键 词</span>：<span>海洋，观测，冲浪</span></div>

							</div>
						</div>
						<div class="bottom">
							<span style="color: #0052D9;"><i class="el-icon-view"
									style="font-size: 20px;"></i>480</span>
							<span style="margin-left:30px;cursor: pointer;" @click="dianzan(1)"
								:style="shoucang?'color: #0052D9;':''"><i class="iconfont icon-zan"
									style="font-size:20px;"></i>9</span>
							<span style="margin-left: 30px;cursor: pointer;"@click="dianzan(2)"
								:style="noLike?'color: #0052D9;':''"><i class="iconfont icon-lacai"
									style="font-size: 20px;"></i>480</span>
							<span style="margin-left: 30px;cursor: pointer;"@click="heartHandler()"
								:style="heart?'color: #0052D9;':''"
							><i class="iconfont icon-xiai"
									style="font-size: 20px;"></i>480</span>
							<span style="margin-left: 30px;cursor: pointer;"@click="shareHandler()"
								:style="share?'color: #0052D9;':''"
							><i class="iconfont icon-fenxiang"
									style="font-size: 20px;"></i>480</span>
						</div>
					</div>
				</div>
				<div class="main-body">
					<div class="title">
						<div :class="'active'">求助摘要</div>

					</div>
					<div class="showItem">
						<div>
							<p :style="!showDetail?'height:25px;white-space:nowrap':''"> 采用Web
								service方式采集台湾气象局等网站发布的海洋观测数据存储到本地数据库,并利用福建NO4浮标数据与台湾马祖浮标数据开展数据比对。结果表明:台湾马祖浮标与福建NO4浮标观测结果相近,散点分布较为集中均匀,相关系数较高。利用202106号台风“烟花”开展同步观测分析,两浮标数据相关性较高,曲线走向也较为一致。利用数据分析,有效评估了台湾海洋浮标观测数据质量,进而说明台湾海洋浮标观测可与东海海洋浮标观测网形成有效互补。

								采用Web
								service方式采集台湾气象局等网站发布的海洋观测数据存储到本地数据库,并利用福建NO4浮标数据与台湾马祖浮标数据开展数据比对。结果表明:台湾马祖浮标与福建NO4浮标观测结果相近,散点分布较为集中均匀,相关系数较高。利用202106号台风“烟花”开展同步观测分析,两浮标数据相关性较高,曲线走向也较为一致。利用数据分析,有效评估了台湾海洋浮标观测数据质量,进而说明台湾海洋浮标观测可与东海海洋浮标观测网形成有效互补。
							</p>
						</div>

					</div>
					<div style="display: flex;justify-content: space-around;">
						<div @click="showDetailHandler" v-if="!showDetail" style="width: 209px;height: 47px;border: 1px solid #0052D9;color: #0052D9;line-height: 47px;text-align: center;cursor: pointer;">
							查看求助详情
							</div>
							<div @click="showDetailHandler" v-else style="width: 209px;height: 47px;border: 1px solid #0052D9;color: #0052D9;line-height: 47px;text-align: center;cursor: pointer;">
								收起
								</div>
						<div style="background: #0052D9;width: 209px;height: 47px;border: 1px solid #0052D9;color: white;line-height: 47px;text-align: center;cursor: pointer;">
							编辑修改
							</div>
					</div>
				</div>
				<div class="main-body">
					<div class="title">
						<div :class="'active'">应助情况</div>
				       
					</div>
					<div class="showItem">
						<div>
							<p class="yingzu">
								<img src='../../assets/images/attion.png' alt="" v-if="false">
								<img src='../../assets/images/duidui.png' alt="">
								<span>用户昵称，2022年12月30日，应助</span><span style="color: #0052D9;">（求助人选择了此方案）</span>
							</p>
							<p class="yingzu">
								<img src='../../assets/images/attion.png' alt="" v-if="false">
								<img src='../../assets/images/duidui.png' alt="">
								<span>用户昵称，2022年12月30日，应助</span><span style="color: #0052D9;">（求助人选择了此方案）</span>
							</p>
							<p class="yingzu">
								<img src='../../assets/images/attion.png' alt="" >
								<img src='../../assets/images/duidui.png' alt="" v-if="false">
								<span style="margin-left: 10px;">用户昵称，2022年12月30日，应助</span><span v-if="false">（求助人选择了此方案）</span>
							</p>
						</div>
						<div class="bottom">尚未有人应助，提交您的资源吧！</div>
					</div>
					
				</div>
			</div>
			<div class="body-right">
				<div class="body-right">
					<div style="background: #0052D9;">
						<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
							style="width:100px">发布</span>
					</div>
					<div style="background: #3399FF;">
						<img src='../../assets/images/share.png' alt="" style="width: 22px;height: 18px;"><span
							style="width:100px">分享</span>
					</div>
					<div style="background: #FF8F00;">
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:100px">关注</span>
					</div>
					<div style="background: #18BC9C;">
						<img src='../../assets/images/circlewen.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:100px">常见问题</span>
					</div>
					<div style="background: #182349;">
						<img src='../../assets/images/zixun.png' alt="" style="width: 20px;height: 19px;"><span
							style="width:100px">咨询作者</span>
					</div>
					<div style="background:#444C69;">
						<img src='../../assets/images/error.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:100px">纠错与修改</span>
					</div>
					<div style="background:#929292;">
						<img src='../../assets/images/bianji.png' alt="" style="width: 19px;height:18px;"><span
							style="width:100px">我有同样需求</span>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				showDetail:false,
				whereForm: "",
				shoucang: false,
				noLike:false,
				heart:false,
				share:false,
				showDetail:false,
			}
		},
		created() {
			this.title = this.$route.meta.title
			console.log(this.title);
		},
		beforeRouteEnter(to, from, next) {
			// that.whereForm = from.meta.title
			next(vm => {
				vm.$data.whereForm = from.meta.title
				console.log(from);
			});
		},
		methods:{
			showDetailHandler(){
				this.showDetail = !this.showDetail
			},
			shareHandler(){
				this.share = !this.share
			},
			heartHandler(){
				this.heart = !this.heart
			},
			dianzan(type){
				if(type == 1){
					this.shoucang = !this.shoucang
					this.noLike = false
				}else{
					this.shoucang = false
					this.noLike = !this.noLike
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.body {
		display: flex;
		justify-content: space-between;

		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			height: 340px;
			background: #FFFFFF;
		}

		.body-main {
			width: 900px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;
					.bottom{
						height: 50px;
						background: #F6F6F6;
						border: 1px solid #EEEEEE;
						margin-top:50px;
						line-height: 50px;
						padding-left: 30px;
						box-sizing: border-box;
						color: black;
					}
					.yingzu{
						display: flex;
						align-items: center;
						margin: 15px 0;
						img{
							width: 18px;
							height: 18px;
						}
						&>span{
							margin-left: 10px;
						}
						&>span:last-child{
							margin-left: 30px;
						}
					}
					p {
						
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.wangpan {
						color: black;
						height: 200px;

						input {
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						width: 128px;
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						width: 128px;
						height: 40px;
						background: #0052D9;
						border-radius: 0px 20px 20px 0px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 20px 5px;
						width: 280px;
					}

					.content-l {}
				}

				.bottom {
					display: flex;
					color: #888888;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 15px;
				}


				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
</style>